export default "__VITE_ASSET__BuMkV0NQ__"